<template>
    <div class="shade-box" :class='{"shade-show":shadebutton}'>
    </div>
</template>
<script>
export default{
    name:'Shade',
    data(){
        return{
            shadebutton:true
        }
    },
    methods:{
        hiddenShade(){
            this.shadebutton=!this.shadebutton
        }
    }
}
</script>
<style scoped>
    .shade-box{
        position: fixed;
        top: 0;
        left: 0;
        background: #1C1C1C;
        width: 100%;
        height: 0vh;
        z-index: 100;
        transition: all 1s;
    }
    .shade-show{
        height: 100vh;
    }
</style>



// WEBPACK FOOTER //
// src/components/base/shade.vue